<template>
  <div class="step3-page">
    <wrapper>
      <template slot="content">
        <div class="step-wrapper">
          <div class="tips">温馨提示：请仔细核对个人信息，如有错误请联系监考人员！</div>
          <div class="content clearfix">
            <img src="~@/assets/images/doExam/tou.png" width="95" height="126" alt="" />
            <div class="info">
              <p class="clearfix">
                <label class="fl">准考证号：</label><span>{{ zkzID }}</span>
              </p>
              <p class="clearfix">
                <label class="fl">姓 名：</label><span>{{ userName ? userName : 'XXX' }}</span>
              </p>
              <p class="clearfix"><label class="fl">性 别：</label><span>X</span></p>
              <p class="clearfix">
                <label class="fl">考试科目：</label><span v-if="courseInfo">{{ courseInfo.courseName }}</span>
              </p>
              <p class="clearfix">
                <label class="fl">证件号码：</label><span>{{ iD }}</span>
              </p>
              <p class="clearfix"><label class="fl">座 位 号：</label><span>111</span></p>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <div class="step-footer">
          <input type="button" value="确认登录" class="submit" @click="goNext" />
          <input type="button" value="返回" class="goBack" @click="toPrev" />
        </div>
      </template>
    </wrapper>
  </div>
</template>

<script>
import wrapper from '@/views/RealMockExam/wrapper';
import { setPageTitle, isEmptyObject, parseNumber, getCookie } from '@/utils';
import { mapGetters } from 'vuex';

export default {
  name: 'step3',
  components: { wrapper },
  data() {
    return {
      userName: getCookie('username'),
      courseInfo: null,
      siteCourseID: '',
      courseID: '',
      zkzID: '11111111',
      iD: '111111111111111111'
    };
  },
  computed: {
    ...mapGetters(['siteData'])
  },
  async mounted() {
    const { flag } = this.$route.params;
    let _flag = flag === 'paidExam' ? '' : flag;
    const { siteCourseID, courseID, zkzID, iD } = this.$route.query;
    const { majorID } = this.$categoryInfo;
    this.siteCourseID = parseNumber(siteCourseID);
    this.courseID = courseID;
    this.zkzID = zkzID;
    this.iD = iD;

    if (isEmptyObject(this.siteData)) {
      let params = {
        flag: _flag,
        majorID: majorID,
        siteCourseID: this.siteCourseID
      };
      await this.$store
        .dispatch('getCurrentSiteInfo', params)
        .then((res) => {
          this.courseInfo = res.currentCourse;
        })
        .catch((err) => {
          this.$message.error(err.msg);
        });
    } else {
      this.courseInfo = this.siteData.currentCourse;
    }
    document.title = setPageTitle(this.courseInfo.siteCourseName);
  },
  methods: {
    toPrev() {
      this.$router.go(-1);
    },
    goNext() {
      const { flag } = this.$route.query
      if (flag === 'ordinary') {
        this.$router.push({
          path: 'step4',
          query: {
            ...this.$route.query,
            zkzID: this.zkzID,
            iD: this.iD
          },
        })
      } else {
        this.$router.push({
          path: 'step4',
          query: {
            siteCourseID: this.siteCourseID,
            courseID: this.courseID,
            zkzID: this.zkzID,
            iD: this.iD
          },
        })
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.step3-page {
  .step-wrapper {
    padding: 10px;
    .tips {
      padding-left: 28px;
      background: url('~@/assets/images/common/tip2.png') no-repeat;
      color: #f70;
      font-size: 13px;
      text-align: center;
      line-height: 30px;
    }
    .content {
      img {
        float: left;
        margin-top: 15px;
      }
      .info {
        float: left;
        width: 270px;
        margin-left: 25px;
        margin-top: 28px;
        p {
          line-height: 25px;
          min-height: 26px;
          font-weight: 700;
          position: relative;
          padding-left: 90px;
          label {
            left: 0;
            position: absolute;
            font-size: 14px;
            color: #006ec8;
            width: auto;
            text-align: right;
            padding-right: 30px;
          }
          span {
            font-size: 14px;
            color: #006ec8;
          }
        }
      }
    }
  }
  .step-footer {
    width: 440px;
    margin: 20px auto 0;
    text-align: center;
    input {
      width: 130px;
      height: 30px;
      font-size: 14px;
      background: #e8661a;
      border: none;
      color: #fff;
      cursor: pointer;
    }
    .submit {
      background: #1f83d1;
      margin-right: 20px;
    }
  }
}
</style>
